import React from "react";
import { Modal, Box, Typography, Divider, Slide } from "@mui/material";
import { ReactComponent as GoldIcon } from "assets/filter/filter header/metal-bar-stainless-steel-construction-svgrepo-com 1.svg"; // Add your gold icon

const GoldPurityModal = ({ open, handleClose, data, title, Icon }) => {
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="gold-purity-modal"
            aria-describedby="gold-purity-breakdown"
            BackdropProps={{ style: { backgroundColor: "transparent" } }}
        >
            <Slide direction="left" in={open} mountOnEnter unmountOnExit timeout={500}>
                <Box
                    sx={{
                        position: "absolute",
                        bottom: 30,
                        right: 30,
                        width: 410,
                        height: 173.054,
                        backgroundColor: "#FFFFFF",
                        borderRadius: "5px 5px 0px 0px",
                        boxShadow: 24,
                        p: "20px 30px",
                        outline: "none",
                        display: "flex",
                        flexDirection: "column",
                        opacity: 1,
                        boxSizing: "border-box",
                    }}
                >
                    {/* Header with Icon */}
                    <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        mb: "20px",
                        height: "24px"
                    }}>
                        <Typography
                            variant="h6"
                            component="h2"
                            sx={{
                                fontWeight: "600",
                                fontFamily: "Poppins",
                                fontSize: "20px",
                                color: "#333",
                                lineHeight: 1
                            }}
                        >
                            {title || "Gold Purity"}
                        </Typography>
                        {Icon ? Icon : <GoldIcon style={{ width: 24, height: 24 }} />}
                    </Box>

                    {/* Divider */}
                    <Divider sx={{
                        backgroundColor: "#E0E0E0",
                        width: "100%",
                        mb: "20px"
                    }} />

                    {/* Dynamic Content */}
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                        flex: 1,
                        gap: "10px",
                        overflowY: "auto"
                    }}>
                        {(data || []).map((item, index) => (
                            <Box
                                key={index}
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%"
                                }}
                            >
                                <Typography sx={{
                                    fontFamily: "Karla",
                                    fontSize: "18px",
                                    color: "#333",
                                    fontWeight: 400
                                }}>
                                    {item.purity}
                                </Typography>
                                <Typography sx={{
                                    fontFamily: "Karla",
                                    fontSize: "18px",
                                    color: "#333",
                                    fontWeight: "bold"
                                }}>
                                    {item.count < 10 ? `0${item.count}` : item.count}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Slide>
        </Modal>
    );
};

export default GoldPurityModal;